export enum FieldMode {
  View = "view",
  GridView = "grid-view",
  Edit = "edit",
  ExtendedView = "extended-view"
}
